import { observer, useLocalStore } from 'mobx-react';
import * as React from 'react';
import { OcDataview } from '../../comps/OcDataview';
import { OcDataviewFiltering } from '../../comps/OcDataviewFiltering';
import { Submenu } from '../../comps/Submenu';
import { useNoSubmenu } from '../../mainpanel/useSubmenu';
import { mg } from '../../mg/mg';
import { mgColumnFactory, MgColumnist } from '../../mg/table/MgColumn';
import { MgEntityEditDialog } from '../../mg/table/MgEntityEditDialog';
import { DataviewStore } from '../../stores/DataviewStore';
import { FilterRepo } from '../../stores/internal/FilterRepo';
import { SortedRepo } from '../../stores/internal/SortedRepo';
import { useOmnistore } from '../../stores/Omnistore';

const columnist = mgColumnFactory.createColumnist([
	'/id',
	'/creationTimestamp :datetime',
	'/timestamp :datetime',
	'customerNo',
	'gln',
	'zipcode',
	'/promocode',
	'/isDeleted =isBlocked',

	null,
	'/template.branch.name =branch',
	'/template.branch.owner.email =owner_email',
	'/template.branch.creationTimestamp :datetime',
	'/joinedTimestamp :datetime =joinedSince',
	'/deliverySchedule',
]);

const dataviewStore = DataviewStore.create({
	id: 'AdmPretemplatePage',
	orgColumns: columnist.descriptors,
	filtering: [{columns: ['customerNo'], value: ''}],
	sorting: {column: 'customerNo'},
});

interface IAdmPretemplateDialogProps {
	columnist: MgColumnist
	entity?: object
	onClose() : void
}

const AdmPretemplateDialog = observer(function AdmPretemplateDialog(props: IAdmPretemplateDialogProps) {
	const omnistore = useOmnistore();
	const {columnist, entity, onClose} = props;
	const editable = useLocalStore(() => columnist.newEntity(entity)) as Record<string, any>;
	function showItem() {
		const router = omnistore.locationStore;
		router.setPage('AdmPretemplateItemPage');
		router.setPretemplateId(editable.id || 0);
		router.setSupplierId(editable.supplierId || 0);
		router.setCustomerNo(editable.customerNo || '');
	}
	return <MgEntityEditDialog
		columnist={columnist}
		extras={columnist.newExtras(editable, {})}
		entity={editable}
		baseName="AdmPretemplateDialog"
		finish={onClose}
		readonly
	>
		{[
			{name: 'items', onClick: showItem},
		]}
	</MgEntityEditDialog>;
});

export const AdmPretemplatePage = observer(function AdmPretemplatePage() {
	const omnistore = useOmnistore();
	columnist.setExternalGet(omnistore.multirepo.externalGet);
	const supplierRepo = new SortedRepo(new FilterRepo(omnistore.multirepo.admSupplierRepo, s => s.kind==='ONLINE'), mg.comparatorOn(s => s.name));
	const supplier = supplierRepo.byId(omnistore.locationStore.supplierId);
	const repo = omnistore.multirepo.admPretemplateRepo(supplier?.id ?? 0);
	React.useEffect(() => {
		omnistore.multirepo.admSupplierRepo.fetch();
		omnistore.multirepo.branchRepo.fetch();
		omnistore.multirepo.templateRepo.fetch();
		omnistore.multirepo.templateRepo.fetch();
	}, []);
	React.useEffect(() => {
		if (supplier?.id) repo.fetch();
	}, [supplier?.id]);
	useNoSubmenu();
	const onDialogClose = () => dataviewStore.rowClick(0);
	const selectedEntity = repo.byId(dataviewStore.selectedEntityId);
	return <>
		<Submenu>
			<OcDataviewFiltering state={dataviewStore} repo={repo}/>
			---
		</Submenu>
		{!supplier?.id ? null : <OcDataview state={dataviewStore} repo={repo}/>}
		{!selectedEntity ? null : <AdmPretemplateDialog entity={selectedEntity} columnist={columnist} onClose={onDialogClose}/>}
	</>;
});
